export const startSSE = ({ url, headers = {}, onEvent, onError }) => {
  const controller = new AbortController();

  const parseEvent = (chunk) => {
    if (!chunk || !chunk.trim()) return;
    const lines = chunk.split("\n");
    let event = "message";
    let data = "";
    lines.forEach((line) => {
      if (line.startsWith("event:")) {
        event = line.replace("event:", "").trim();
      } else if (line.startsWith("data:")) {
        const payload = line.replace("data:", "").trim();
        data += payload;
      }
    });
    if (!data) return;
    try {
      const parsed = JSON.parse(data);
      onEvent?.(event, parsed);
    } catch (error) {
      onError?.(error);
    }
  };

  fetch(url, { headers, signal: controller.signal })
    .then(async (response) => {
      if (!response.body) {
        throw new Error("Streaming not supported in this browser.");
      }
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        let boundary = buffer.indexOf("\n\n");
        while (boundary !== -1) {
          const chunk = buffer.slice(0, boundary);
          buffer = buffer.slice(boundary + 2);
          parseEvent(chunk);
          boundary = buffer.indexOf("\n\n");
        }
      }
    })
    .catch((error) => {
      if (controller.signal.aborted) return;
      onError?.(error);
    });

  return () => controller.abort();
};


